/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { PatternString } from "@pagopa/ts-commons/lib/strings";

/**
 * details for the specific payment instrument. This field is disciminated by the type field
 */

/**
 * Card payment instrument details
 */

// required attributes
const WalletInfoDetails1R = t.interface({
  type: t.string,

  lastFourDigits: t.string,

  expiryDate: PatternString("^[0-9]{6}$"),

  brand: t.string
});

// optional attributes
const WalletInfoDetails1O = t.partial({});

export const WalletInfoDetails1 = t.intersection(
  [WalletInfoDetails1R, WalletInfoDetails1O],
  "WalletInfoDetails1"
);

export type WalletInfoDetails1 = t.TypeOf<typeof WalletInfoDetails1>;

/**
 * Paypal instrument details
 */

// required attributes
const WalletInfoDetails2R = t.interface({
  type: t.string,

  pspId: t.string,

  pspBusinessName: t.string
});

// optional attributes
const WalletInfoDetails2O = t.partial({
  maskedEmail: t.string
});

export const WalletInfoDetails2 = t.intersection(
  [WalletInfoDetails2R, WalletInfoDetails2O],
  "WalletInfoDetails2"
);

export type WalletInfoDetails2 = t.TypeOf<typeof WalletInfoDetails2>;

export const WalletInfoDetails = t.union(
  [WalletInfoDetails1, WalletInfoDetails2],
  "WalletInfoDetails"
);

export type WalletInfoDetails = t.TypeOf<typeof WalletInfoDetails>;
